/**
 * Fängt Render-Fehler einer Seite ab, statt die ganze App weiß zu reißen
 * (z. B. bei unerwarteten API-Antwortformen). Zeigt eine Fehlerkarte mit
 * Details + Aktionen; ein Routenwechsel setzt den Zustand automatisch zurück.
 */

import { Component, type ReactNode } from 'react';
import { Icon } from './Icon.tsx';

interface Props {
  /** Bei Änderung (z. B. Pfad) wird ein gefangener Fehler zurückgesetzt. */
  resetKey?: string;
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidUpdate(prev: Props) {
    if (this.state.error && prev.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="max-w-xl mx-auto mt-16">
        <div className="card">
          <div className="card-body text-center">
            <div className="w-12 h-12 rounded-full bg-accent-50 dark:bg-accent-600/15 text-accent-600 flex items-center justify-center mx-auto mb-4">
              <Icon name="alertTriangle" size={22} />
            </div>
            <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">
              Diese Seite konnte nicht dargestellt werden
            </h2>
            <p className="text-sm text-slate-500 dark:text-slate-400 mt-1.5">
              Ein unerwarteter Fehler ist aufgetreten. Neu laden behebt das meistens —
              falls nicht, hilft der Fehlertext unten bei der Suche nach der Ursache.
            </p>
            <div className="mt-4 flex items-center justify-center gap-2">
              <button className="btn-primary" onClick={() => window.location.reload()}>
                Neu laden
              </button>
              <a href="/statistik/" className="btn-secondary no-underline">
                Zum Dashboard
              </a>
            </div>
            <pre className="mt-5 text-left font-mono text-2xs text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-800/60 rounded-md p-3 overflow-x-auto">
              {String(this.state.error)}
            </pre>
          </div>
        </div>
      </div>
    );
  }
}
